import { ProgressBar } from 'react-bootstrap';
import { calculatePasswordStrength } from '../utils/validation';

interface PasswordStrengthMeterProps {
  password: string;
}

/**
 * Live visual indicator of password strength shown beneath a new-password field.
 * Renders nothing until the user starts typing.
 */
const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({ password }) => {
  if (!password) {
    return null;
  }

  const { label, percent, variant } = calculatePasswordStrength(password);

  return (
    <div className="mt-2" aria-live="polite">
      <ProgressBar now={percent} variant={variant} style={{ height: '6px' }} />
      <small className={`text-${variant}`}>Password strength: {label}</small>
    </div>
  );
};

export default PasswordStrengthMeter;
